//
// Copyright 2022 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/halo/credentials.proto.
 */
export const file_dxos_halo_credentials = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_any, file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_echo_timeframe, file_dxos_keys]);
/**
 * Describes the message dxos.halo.credentials.SpaceGenesis.
 * Use `create(SpaceGenesisSchema)` to create a new message.
 */
export const SpaceGenesisSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 0);
/**
 * Describes the message dxos.halo.credentials.SpaceMember.
 * Use `create(SpaceMemberSchema)` to create a new message.
 */
export const SpaceMemberSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 1);
/**
 * TODO(burdon): Consider union of capabilities; e.g., APPEND_ONLY, READ_ONLY, EPOCH_GENERATOR?
 *
 * @generated from enum dxos.halo.credentials.SpaceMember.Role
 */
export var SpaceMember_Role;
(function (SpaceMember_Role) {
    /**
     * @generated from enum value: INVALID = 0;
     */
    SpaceMember_Role[SpaceMember_Role["INVALID"] = 0] = "INVALID";
    /**
     * / Manage members.
     *
     * @generated from enum value: ADMIN = 1;
     */
    SpaceMember_Role[SpaceMember_Role["ADMIN"] = 1] = "ADMIN";
    /**
     * / Read and write.
     *
     * @generated from enum value: EDITOR = 2;
     */
    SpaceMember_Role[SpaceMember_Role["EDITOR"] = 2] = "EDITOR";
    /**
     * / Read-only.
     *
     * @generated from enum value: READER = 3;
     */
    SpaceMember_Role[SpaceMember_Role["READER"] = 3] = "READER";
    /**
     * / Admin that can't be removed.
     *
     * @generated from enum value: OWNER = 4;
     */
    SpaceMember_Role[SpaceMember_Role["OWNER"] = 4] = "OWNER";
    /**
     * / Revoked membership.
     *
     * @generated from enum value: REMOVED = 5;
     */
    SpaceMember_Role[SpaceMember_Role["REMOVED"] = 5] = "REMOVED";
})(SpaceMember_Role || (SpaceMember_Role = {}));
/**
 * Describes the enum dxos.halo.credentials.SpaceMember.Role.
 */
export const SpaceMember_RoleSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_credentials, 1, 0);
/**
 * Describes the message dxos.halo.credentials.MemberProfile.
 * Use `create(MemberProfileSchema)` to create a new message.
 */
export const MemberProfileSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 2);
/**
 * Describes the message dxos.halo.credentials.SpaceDeleted.
 * Use `create(SpaceDeletedSchema)` to create a new message.
 */
export const SpaceDeletedSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 3);
/**
 * Describes the message dxos.halo.credentials.AuthorizedDevice.
 * Use `create(AuthorizedDeviceSchema)` to create a new message.
 */
export const AuthorizedDeviceSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 4);
/**
 * Describes the message dxos.halo.credentials.AdmittedFeed.
 * Use `create(AdmittedFeedSchema)` to create a new message.
 */
export const AdmittedFeedSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 5);
/**
 * @generated from enum dxos.halo.credentials.AdmittedFeed.Designation
 */
export var AdmittedFeed_Designation;
(function (AdmittedFeed_Designation) {
    /**
     * / Classic general purpose feeds for both HALO and ECHO messages together. To be deprecated.
     *
     * @generated from enum value: GENERAL = 0;
     */
    AdmittedFeed_Designation[AdmittedFeed_Designation["GENERAL"] = 0] = "GENERAL";
    /**
     * / Contain system-level messages messages, such as credentials and epochs.
     *
     * @generated from enum value: CONTROL = 1;
     */
    AdmittedFeed_Designation[AdmittedFeed_Designation["CONTROL"] = 1] = "CONTROL";
    /**
     * / Database mutations.
     *
     * @generated from enum value: DATA = 2;
     */
    AdmittedFeed_Designation[AdmittedFeed_Designation["DATA"] = 2] = "DATA";
})(AdmittedFeed_Designation || (AdmittedFeed_Designation = {}));
/**
 * Describes the enum dxos.halo.credentials.AdmittedFeed.Designation.
 */
export const AdmittedFeed_DesignationSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_credentials, 5, 0);
/**
 * Describes the message dxos.halo.credentials.Epoch.
 * Use `create(EpochSchema)` to create a new message.
 */
export const EpochSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 6);
/**
 * Describes the message dxos.halo.credentials.HaloSpace.
 * Use `create(HaloSpaceSchema)` to create a new message.
 */
export const HaloSpaceSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 7);
/**
 * Describes the message dxos.halo.credentials.IdentityRecovery.
 * Use `create(IdentityRecoverySchema)` to create a new message.
 */
export const IdentityRecoverySchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 8);
/**
 * / How the recovery key is held. Determines how it is presented and how it is redeemed.
 *
 * @generated from enum dxos.halo.credentials.IdentityRecovery.Kind
 */
export var IdentityRecovery_Kind;
(function (IdentityRecovery_Kind) {
    /**
     * / Written before this field existed; infer from `algorithm` and treat as unlabelled.
     *
     * @generated from enum value: UNKNOWN = 0;
     */
    IdentityRecovery_Kind[IdentityRecovery_Kind["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * / WebAuthn passkey held by an authenticator (password manager, platform keychain, security key).
     *
     * @generated from enum value: PASSKEY = 1;
     */
    IdentityRecovery_Kind[IdentityRecovery_Kind["PASSKEY"] = 1] = "PASSKEY";
    /**
     * / Seed-phrase recovery code held by the user.
     *
     * @generated from enum value: RECOVERY_CODE = 2;
     */
    IdentityRecovery_Kind[IdentityRecovery_Kind["RECOVERY_CODE"] = 2] = "RECOVERY_CODE";
    /**
     * / Recovery delegated to an OAuth provider.
     *
     * @generated from enum value: OAUTH = 3;
     */
    IdentityRecovery_Kind[IdentityRecovery_Kind["OAUTH"] = 3] = "OAUTH";
})(IdentityRecovery_Kind || (IdentityRecovery_Kind = {}));
/**
 * Describes the enum dxos.halo.credentials.IdentityRecovery.Kind.
 */
export const IdentityRecovery_KindSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_credentials, 8, 0);
/**
 * Describes the message dxos.halo.credentials.IdentityRecoveryRevoked.
 * Use `create(IdentityRecoveryRevokedSchema)` to create a new message.
 */
export const IdentityRecoveryRevokedSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 9);
/**
 * Describes the message dxos.halo.credentials.SpaceInvitationNotice.
 * Use `create(SpaceInvitationNoticeSchema)` to create a new message.
 */
export const SpaceInvitationNoticeSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 10);
/**
 * Describes the message dxos.halo.credentials.ProfileDocument.
 * Use `create(ProfileDocumentSchema)` to create a new message.
 */
export const ProfileDocumentSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 11);
/**
 * Describes the message dxos.halo.credentials.IdentityProfile.
 * Use `create(IdentityProfileSchema)` to create a new message.
 */
export const IdentityProfileSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 12);
/**
 * Describes the message dxos.halo.credentials.DeviceProfileDocument.
 * Use `create(DeviceProfileDocumentSchema)` to create a new message.
 */
export const DeviceProfileDocumentSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 13);
/**
 * Describes the message dxos.halo.credentials.DeviceProfile.
 * Use `create(DeviceProfileSchema)` to create a new message.
 */
export const DeviceProfileSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 14);
/**
 * Describes the message dxos.halo.credentials.DefaultSpace.
 * Use `create(DefaultSpaceSchema)` to create a new message.
 */
export const DefaultSpaceSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 15);
/**
 * Describes the message dxos.halo.credentials.KubeAccess.
 * Use `create(KubeAccessSchema)` to create a new message.
 */
export const KubeAccessSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 16);
/**
 * Describes the message dxos.halo.credentials.ServiceAccess.
 * Use `create(ServiceAccessSchema)` to create a new message.
 */
export const ServiceAccessSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 17);
/**
 * Describes the message dxos.halo.credentials.KeyInfo.
 * Use `create(KeyInfoSchema)` to create a new message.
 */
export const KeyInfoSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 18);
/**
 * Describes the message dxos.halo.credentials.Auth.
 * Use `create(AuthSchema)` to create a new message.
 */
export const AuthSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 19);
/**
 * Describes the message dxos.halo.credentials.Claim.
 * Use `create(ClaimSchema)` to create a new message.
 */
export const ClaimSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 20);
/**
 * Describes the message dxos.halo.credentials.Proof.
 * Use `create(ProofSchema)` to create a new message.
 */
export const ProofSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 21);
/**
 * Describes the message dxos.halo.credentials.Chain.
 * Use `create(ChainSchema)` to create a new message.
 */
export const ChainSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 22);
/**
 * Describes the message dxos.halo.credentials.Credential.
 * Use `create(CredentialSchema)` to create a new message.
 */
export const CredentialSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 23);
/**
 * Describes the message dxos.halo.credentials.Presentation.
 * Use `create(PresentationSchema)` to create a new message.
 */
export const PresentationSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_credentials, 24);
/**
 * @generated from enum dxos.halo.credentials.MembershipPolicy
 */
export var MembershipPolicy;
(function (MembershipPolicy) {
    /**
     * / Members can be invited by admins/owners.
     *
     * @generated from enum value: INVITE = 0;
     */
    MembershipPolicy[MembershipPolicy["INVITE"] = 0] = "INVITE";
    /**
     * / No new members can be added after genesis.
     *
     * @generated from enum value: LOCKED = 1;
     */
    MembershipPolicy[MembershipPolicy["LOCKED"] = 1] = "LOCKED";
})(MembershipPolicy || (MembershipPolicy = {}));
/**
 * Describes the enum dxos.halo.credentials.MembershipPolicy.
 */
export const MembershipPolicySchema = /*@__PURE__*/ enumDesc(file_dxos_halo_credentials, 0);
/**
 * @generated from enum dxos.halo.credentials.DeviceType
 */
export var DeviceType;
(function (DeviceType) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    DeviceType[DeviceType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: BROWSER = 1;
     */
    DeviceType[DeviceType["BROWSER"] = 1] = "BROWSER";
    /**
     * @generated from enum value: NATIVE = 2;
     */
    DeviceType[DeviceType["NATIVE"] = 2] = "NATIVE";
    /**
     * TODO(wittjosiah): Rename "agent" to avoid naming collision with AI agents.
     * TODO(wittjosiah): Unknown, Browser, CLI, Desktop, Mobile, Custodian?
     *
     * @generated from enum value: AGENT = 3;
     */
    DeviceType[DeviceType["AGENT"] = 3] = "AGENT";
    /**
     * @generated from enum value: AGENT_MANAGED = 4;
     */
    DeviceType[DeviceType["AGENT_MANAGED"] = 4] = "AGENT_MANAGED";
    /**
     * @generated from enum value: MOBILE = 5;
     */
    DeviceType[DeviceType["MOBILE"] = 5] = "MOBILE";
})(DeviceType || (DeviceType = {}));
/**
 * Describes the enum dxos.halo.credentials.DeviceType.
 */
export const DeviceTypeSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_credentials, 1);
//# sourceMappingURL=credentials_pb.js.map